import ConnectivityService from "./connectivity-service";
import RouterService from "./router-service";
import StaticIPService from "./static-ip-service";
import SubnetService from "./subnet-service";
import VoiceService from "./voice-service";
import logger from "../../logger";

export default class ConnectivityClotService {

  constructor(service_details)
  {
    logger.debug('service_details', service_details)
    logger.debug('THIS SHOULD ONLY BE CALLED TWICE')
    service_details = JSON.parse(JSON.stringify(service_details))
    this.address_details = service_details.address_details;
    this.is_available = this.address_details.available;
    this.speed_options = [];
    if (this.isAvailable()) {
      this.service_details = service_details.service;
      this.service_class_model = this.service_details.service_class_model;

      this.connectivity = new ConnectivityService(this.service_details.connectivity, this.address_details);
      this.router = new RouterService(this.service_details.router, this.address_details);
      this.voice = new VoiceService(this.service_details.voice, this.address_details);
      this.static_ip = new StaticIPService(this.service_details.static_ip);
      this.subnet = new SubnetService(this.service_details.subnet);
    }
  }

  isAvailable() {
    return this.is_available;
  }

  setSpeedOptionsForSelect() {
    logger.debug('setSpeedOptionsForSelect', this)
    let promo_labels = [];
    let speed_options = {speed_options: [], promo_legal_disclaimers: []};
    let router_legal_disclaimers = [];
    if (!this.isAvailable) {
      return;
    }
    let total_speed_options = this.connectivity.speedOptions();
    // Construct speed options to be used to the SpeedSelect component
    for (let speed_option of total_speed_options) {
      let router_option = this.router.routerOptions().filter(x => x.speed_id === speed_option.speed_id);
      let connectivity_promo = this.connectivity.onlinePromo(speed_option);
      let connectivity_promos = speed_option.billing.promos;
      let router_promo = null;
      let router_promo_rate = 0.;
      // routers may not be available for a speed
      if (router_option.length === 1) {
        router_option = router_option[0];
        router_promo = this.router.onlinePromo(router_option);
        if (router_promo) {
          router_promo_rate = router_promo.rate;
        }
      }
      let router_promos = router_option.billing.promos;
      let monthly_gross_connectivity_rate = this.connectivity.grossServiceOptionMonthlyCost(speed_option);
      let early_net_connectivity_rate = this.connectivity.grossOneTimeXMissionCost(speed_option);
      let monthly_gross_connectivity_router_rate = monthly_gross_connectivity_rate - router_promo_rate;
      speed_options.speed_options.push({download_speed: speed_option.download_speed,
                                        speed_id: speed_option.speed_id,
                                        external_soid: speed_option.external_soid,
                                        speed_label: speed_option.label,
                                        speed_description: speed_option.description,
                                        speed_color: speed_option.color,
                                        symmetric: speed_option.symmetric,
                                        monthly_gross_connectivity_rate: monthly_gross_connectivity_rate,
                                        monthly_gross_connectivity_rate_breakdown: this.connectivity.monthlyPriceFeeServiceOptionBreakdownString(speed_option),
                                        has_connectivity_promo: Boolean(connectivity_promos),
                                        early_net_connectivity_rate_term: this.connectivity.getRateTermString(connectivity_promo, early_net_connectivity_rate, false),
                                        has_router_promo: Boolean(router_promo),
                                        monthly_gross_connectivity_router_rate: monthly_gross_connectivity_router_rate});
      for (let promo of connectivity_promos) {
        // add connectivity promo disclaimer but avoid duplicates
        if (!promo_labels.includes(connectivity_promo.legal_label)){
          promo_labels.push(connectivity_promo.legal_label);
          speed_options.promo_legal_disclaimers.push({label: connectivity_promo.legal_label, disclaimer: connectivity_promo.legal_description});
        }
      }
      // add router promo disclaimer but avoid duplicates
      for (let promo of router_promos) {
        if (!promo_labels.includes(promo.legal_label)){
          promo_labels.push(promo.legal_label);
          // we add the router promo disclaimer separately so we can add them later
          router_legal_disclaimers.push({label: promo.legal_label, disclaimer: promo.legal_description});
        }
      }
    }
    // add router promo disclaimers
    speed_options.promo_legal_disclaimers = speed_options.promo_legal_disclaimers.concat(router_legal_disclaimers);
    // Sort the speed options by download speed
    speed_options.speed_options = speed_options.speed_options.sort((a, b) => Number(a.download_speed) - Number(b.download_speed));
    this.speed_options = speed_options;
  }
}



// WEBPACK FOOTER //
// ./src/lib/ssu/input_models/connectivity-clot-service.js